export enum RouteType {
    default,
    search,
    updateSearch,
    results,
    topicsHype,
    topic,
    topicUpdate,
    subscriptionsHype,
    subscription,
    subscriptionResults,
    subscriptionDashboard,
    folder,
    mentions,
    mentionsHype,
    topicAnalyticsDashboard,
    adHocAnalyticsDashboard,
    folderAnalyticsDashboard,
    subscriptionAnalyticsDashboard,
    allSavedCoverageAnalyticsDashboard,
    briefingsHype,
    briefing,
    briefingReport,
    recurringBriefingReport,
    canvas,
    canvasReport,
    recurringCanvasReport,
    alertsHype,
    alert,
    recurringAlertReport,
    reportsHype,
    report,
    reportSharedReports,
    topicAnalyticsSyndicates,
    adHocAnalyticsSyndicates,
    folderAnalyticsSyndicates,
    subscriptionAnalyticsSyndicates,
    allSavedCoverageAnalyticsSyndicates,
}
